// All warehouse layout numbers live here. Change them and the UI follows.
//
// Per zone:
//   racks              - number of racks in the zone
//   aisles             - number of aisles (laid out between racks: R A R A R ...)
//   shelvesPerRack     - shelves shown when a rack is clicked
//   slotsPerShelf      - slots per shelf (only used when usesPallets is true)
//   usesPallets        - dry shelves hold pallets in slots; chilled/frozen do not
//   floorSlotsPerAisle - floor slots where goods can be laid down in an aisle

const DRY = {
  key: 'dry',
  label: 'Dry Foods',
  racks: 5,
  aisles: 4,
  shelvesPerRack: 4,
  slotsPerShelf: 6,
  usesPallets: true,
  floorSlotsPerAisle: 6,
};

const CHILLED = {
  key: 'chilled',
  label: 'Fridge (Chilled)',
  racks: 3,
  aisles: 2,
  shelvesPerRack: 3,
  slotsPerShelf: 4,
  usesPallets: true,
  floorSlotsPerAisle: 4,
};

const FROZEN = {
  key: 'frozen',
  label: 'Freezer (Frozen)',
  racks: 4,
  aisles: 3,
  shelvesPerRack: 2,
  slotsPerShelf: 5,
  usesPallets: true,
  floorSlotsPerAisle: 4,
};

const build = (overrides = {}) => [
  { ...DRY, ...(overrides.dry || {}) },
  { ...CHILLED, ...(overrides.chilled || {}) },
  { ...FROZEN, ...(overrides.frozen || {}) },
];

export const WAREHOUSES = [
  { id: 'main', name: 'Main', zones: build() },
  // Springvale and Clayton use the same defaults for now; override per zone as needed,
  // e.g. build({ dry: { racks: 3, aisles: 2 } })
  { id: 'springvale', name: 'Springvale', zones: build() },
  { id: 'clayton', name: 'Clayton', zones: build() },
];
